import {Observable} from "rxjs";
import {Settings} from "./settings.model";
import {Headers, Http, RequestMethod, Response, ResponseContentType, URLSearchParams} from "@angular/http";
import {RequestLog} from "./requestlog.model";

export abstract class Request {
    protected settings: Settings;
    protected http: Http;

    constructor(http: Http, settings: Settings) {
        this.http     = http;
        this.settings = settings;
    }

    protected createSearch(search?: any, prefix?: string): URLSearchParams {
        var params = new URLSearchParams();

        if (search) {
            for (let i in search) {
                let key = prefix ? prefix + '[' + i + ']' : i;

                if (typeof search[i] === 'object') {
                    params.setAll(this.createSearch(search[i], key));
                    continue;
                }

                params.set(key, search[i]);
            }
        }

        return params;
    }

    protected get(uri: string, search?: URLSearchParams): Observable<any> {
        return this.request(RequestMethod.Get, uri, search);
    }

    protected post(uri: string, body: any): Observable<any> {
        return this.request(RequestMethod.Post, uri, null, body);
    }

    protected put(uri: string, body: any): Observable<any> {
        return this.request(RequestMethod.Put, uri, null, body);
    }

    protected patch(uri: string, body: any): Observable<any> {
        return this.request(RequestMethod.Patch, uri, null, body);
    }

    protected delete(uri: string): Observable<any> {
        return this.request(RequestMethod.Delete, uri);
    }

    private request(method: RequestMethod, uri: string, search?: URLSearchParams, body?: any, headers?: Headers): Observable<any>{
        let url = this.settings.apiUrl + uri;
        headers = headers || new Headers();

        if ([RequestMethod.Post, RequestMethod.Patch, RequestMethod.Put].indexOf(method) !== -1) {
            headers.set('Content-Type', 'application/json');
        }

        if (this.settings.token) {
            headers.set('Authorization', 'token ' + this.settings.token);
        }

        var methodString: string;

        switch (method) {
            case RequestMethod.Delete:
                methodString = 'DELETE';
                break;
            case RequestMethod.Get:
                methodString = 'GET';
                break;
            case RequestMethod.Patch:
                methodString = 'PATCH';
                break;
            case RequestMethod.Post:
                methodString = 'POST';
                break;
            case RequestMethod.Put:
                methodString = 'PUT';
                break;
            default:
                methodString = 'UNKNOWN';
                break;
        }

        if (this.settings.debug) {
            console.debug('Request:  [' + methodString + '] ' + url + (search ? '?' + search.toString() : ''));
            if (body) {
                console.debug('Body:     ' + JSON.stringify(body));
            }
        }

        let logRequest = (response: Response) => {
            if (this.settings.debug === true) {
                let responseString = response ? response.json() : null;
                console.debug('Response: [' + response.status + ']: ' + JSON.stringify(responseString));
            }

            this.settings.api.logRequest(new RequestLog(
                url + (search ? '?' + search.toString() : ''),
                methodString,
                body,
                response.status,
                response.json()
            ));
        };

        let request = this.http.request(
            url,
            {
                url             : url,
                method          : method,
                search          : search,
                headers         : headers,
                body            : body,
                withCredentials : !!this.settings.token,
                responseType    : ResponseContentType.Json
            }
        ).map((response: Response) => {
            logRequest(response);

            return this.handleResponse(response);
        }).catch((response: Response) => {
            logRequest(response);

            return this.handleErrors(response);
        });

        return request;
    };

    private handleResponse(response: Response) {
        if (!response) {
            return null;
        }

        let json = response.json();

        return json.data;
    }

    private handleErrors(error: Response) {
        let errors = error.json();

        if (error.status === 401) {
            this.settings.eventEmitter.emit(error.status);
        }

        if (errors.length === 1) {
            return Observable.throw(errors[0]);
        }

        return Observable.throw(errors);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/request.abstract.ts